import classNames from 'classnames';
import React from 'react';
import './index.scss';

export interface EcoTitleProps {
    /**
     * 主题色
     */
    title?: React.ReactNode;
    /**
     * 自定义类名
     */
    className?: string;
}

/**
 * 主标题
 */
const EcoTitle: React.FC<EcoTitleProps> = ({ title, className }) => {
    const prefixCls = `eco-title`;
    const compCls = classNames(prefixCls, {
        [`${className}`]: className,
    });

    return <div className={compCls}>{title}</div>;
};

export default EcoTitle;
